import { InputIconLeftMemoized, InputIconMemoized } from "./styles"
import { InputIconProps } from "./types"

export const InputIconLeft = (props: InputIconProps) => (
  <InputIconLeftMemoized {...props} />
)
export const InputIcon = (props: InputIconProps) => <InputIconMemoized {...props} />
